<template>
  <div class="chat-window">
    <!-- 显示聊天消息的容器 -->
    <div class="panel" v-if="messages.length<=0" :style="{marginTop:pheight}"  ref="panelscroll">
      <div style="overflow: hidden;">
      <img style = "width: 330px;height: 80px;margin-bottom: 134px;margin-top: 90px;" src="@/assets/ai/title.png"/>
      <div class="modlePanel">
        <a-carousel arrows  :dots='false'
        >
          <div
            slot="prevArrow"
            class="custom-slick-arrow"
            style="left: 10px;zIndex: 1"
          >
            <a-icon type="left" />
          </div>
          <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
            <a-icon type="right" />
          </div>
          <div v-for="(modle,index) in modles" :key="index">
            <div style="margin-left: 90px;display: flex; margin-top:5px;flex-direction: row;  flex-wrap: wrap;justify-content: left;align-items:center">
              <div v-for="(m,i) in modle" :key="i">
                <div class="modle" :class="pindex == index&& piindex == i?'modle1':'modle2'" @mouseover="onPanelEnter(index,i)" @mouseout="onPanelOut" @click="onPanel(index,i,m.applyId,m.content)">
                  <img style = "width: 40px;height: 40px;" :src="m.imgUrl"/>
                  <div style="width:280px"><span>{{m.title}}</span></div>
                  <div style="width:280px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"><span>{{m.digest}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
      </div>
    </div>
    <div class="message-container" :style="{height:mheight}" v-else>
      <div style="overflow-y: scroll;   scrollbar-width: none;
      -ms-overflow-style: none;;" ref="mianscroll">
          <div style="  display: flex;flex-direction: column;"  >
            <div v-for="message in messages" :key="message.id">
              <div v-if="message.time" class="time-text">{{message.time}}</div>
                <!-- 机器人 -->
                <div v-if="!message.isMe" class="left-box">
                  <div class="user-img">
                    <img class="auto-img" src="@/assets/ai/head1.png" alt="">
                  </div>
                  <div class="content-box" >
                    <!-- <a-tooltip placement="bottom" title="点击复制" arrow-point-at-center
                    :mouseLeaveDelay='0.2'
                    :mouseEnterDelay='0.2'
                    overlayStyle="background-color:'rgba(240, 242, 245, 1);'"
                    > -->
                    <!-- <div class="user user-robot">小爱同学</div> -->
                      <div v-resize="handleResize" ref="msgref" class="user-msg other-msg" :class="message.id ==isMsgEnter ? 'pick-msg' : ''" @mouseover="onMsgEnter(message.id)" @mouseout="onMsgOut">
                        <!-- <i class="caret caret-left"></i> -->
                        <Typed  v-if="!message.isnType" ref="typeref" :typedList=[message.text] :onEnd="onMsgEnd"></Typed>
                        <div  v-else v-html="message.text" ></div>
                        <!-- <p>{{message.text}}</p> -->
                      </div>

                      
                      <a-button class="lbtn" icon="copy"    key="submit" 
                        type="primary" v-clipboard:copy="!message.isnType?getCopyType(message.id):message.text" v-clipboard:success="copyUrl"
                        v-clipboard:error="onError" >
                      </a-button>
                    <!-- </a-tooltip> -->
                  </div>
                </div>
              <!-- 我 -->
              <div v-else-if="message.isMe" class="left-box">
                  <div class="user-img">
                    <img class="auto-img" src="@/assets/ai/head2.png" alt="">
                  </div>
                  <div class="content-box">
                    <!-- <div class="user user-robot">小爱同学</div> -->
                    <div class="user-msg my-msg" :class="message.id ==isMsgEnter ? 'pick-msg1' : ''" @mouseover="onMsgEnter(message.id)" @mouseout="onMsgOut">
                        <!-- <i class="caret caret-left"></i> -->
                    <!-- <div class="user-msg my-msg"> -->
                      <!-- <i class="caret caret-left"></i> -->
                      <div  v-html="message.text" ></div>
                      <!-- <p>{{message.text}}</p> -->
                    </div>
                  </div>
                <!-- <div class="user-img user-img-right">
                    <img class="auto-img" src="@/assets/ai/head1.png" alt="">
                  </div>
                  <div class="content-box">
                
                    <div class="user-msg my-msg">
                      <Typed :typedList="
                      <div  v-html="message.text"></div>
                    </div>
                  </div> -->
                  
              </div>

              <!-- <div v-if="message.isMe" class=" mine">
            
                <div  class="message message-text ">{{ message.text }}</div>
                <img class="item-img" src="@/assets/ai/avatar.png" />
              </div>
            <div v-else class="  other">
              <img class="item-img" src="@/assets/ai/avatar.png" />
              <div  class="message message-text " v-html="message.text"></div>   
            </div> -->
              
            </div>
          </div>
      </div>
    </div>
    <div class="inputs" ref="inputref">
      <!-- 输入消息的表单 -->
      <!-- <form @submit.prevent="sendMessage" class="input-form"> -->
        <!-- <input v-model="inputText" type="text" placeholder="输入消息" /> -->
        <!-- <button type="submit">发送</button> -->
        <!-- <a-button class ='icon-btn' type="primary" shape="circle" loading /> -->
        <!-- <div>
          <img src="@/assets/ai/send.png"/>
          <a-icon style="fontSize:20px" type="loading-3-quarters" spin />
        </div> -->
        <!-- <a-button @mouseenter="onMsgIconEnter(i,ii,0)"  @click="onEdit(i,ii,ii)" @mouseleave="onIconMsgOut" icon="edit" :class="i==index&&ii==iindex&&emindex==0?'icon-btn1':'icon-btn2'"> </a-button> -->
        
      <!-- </form> -->
      <!-- @keydown.enter.exact.prevent="sendTextMessage" -->
      <!-- @keyup.enter.91="sendTextMessage" -->
      <!-- @keyup.enter="keyupEnter" -->
      <!-- @keydown="keyupCEnter" -->
      <!-- @input="onBlur"  contenteditable="true" -->
      <div  class="edits" :class="eFocus?'edits1':'edits2'" ref="escroll"  
        @keydown.enter.exact.prevent="keyupEnter"
        @keyup.enter.ctrl.prevent.exact="sendTextMessage"
        v-meta-enter="keyupCEnter"
     >
          <!-- <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
          /> -->
           <!-- v-resize="handleResizeInput" -->
          <Editor 
              style="min-height: 40px; max-height: 200px; width:600px"
              v-model="html"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
              @onDestroyed="onDestroyed"
              @customPaste="customPaste"
              @onFocus="onFocus"
              @onBlur="onBlur"
              @onChange="onChange"
             
          />
       

      </div>
      <div class="opedit" :class="pickSend==0?'opedit1':'opedit2'">
            <img :class="editor&&getEmptyText(editor.getText())?'img':'img1'" v-if='pickSend!=1' @mouseenter="onSendEnter" @mouseleave="onSendOut"  src="@/assets/ai/send.png" @click="sendMessage"/>
            <a-icon v-else style="fontSize:20px" type="loading-3-quarters" spin />
          </div>
    </div>
  </div>
</template>
 <!-- <Typed :typedList="['<p>测试打字机第一行测试打字机第一行测试打字机第一行测试打字机第一行测试打字机第一行测试打字机第一行</p>', '测试第二行',
  '<p>测试第二行</p>','测试第二行','测试第二行','测试第二行','测试第二行']" /> -->
<script>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import Typed from "./aitype.vue";
import { aiapi } from './aiapi';
//import elementResizeDetectorMaker from "element-resize-detector";
export default {
  components: { Editor, Toolbar,  Typed},
  props: {
    onEnd: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      messages: [
        // { id: 1, text: '你好', isMe: false },
        // { id: 2, text: 'Hi', isMe: true },
      ],
      modles:[[
        {applyId:1,title:"",digest:'',content:'',imgUrl:''},
       {applyId:1,title:"",digest:'',content:'',imgUrl:''},
       {applyId:1,title:"",digest:'',content:'',imgUrl:''},
        {applyId:1,title:"",digest:'',content:'',imgUrl:''}],
        [ {applyId:1,title:"",digest:'',content:'',imgUrl:''}]
      ],
      mheight:'635px',
      pheight:'635px',
      sendBtnOff:'-42px',
      editor: null,
      html: '',
      htmlScrol:'',
      //htmlScrollTop:'',
      toolbarConfig: { },
      editorConfig: { placeholder: '请输入内容...' ,
          lineHeight:0.5,
          MENU_CONF:{'lineHeight' :{
             lineHeightList: ['0.5'],
            //lineHeight:0.5
            //default:'0.5'
      }}},
      mode: 'simple',//'default', // or 'simple'
      isMsgEnter:'',
      pickSend:-1,//0 滑过，1发送中
      eFocus:false,
      pindex:-1,
      piindex:-1,
      applyId:'',
      conversation:'',//会话id
      typeMsgLisg:{},
      // msgdef:'',
    };
  },
  mounted() {
  
    this.getData();
    // this.bottomScrollClick()
    // this.editor.focus()
    // this.onFocus();

    // window.onkeydown = function (e) {
    //   console.log(e.keyCode);
    // }
  },
  // watch: {
  //   msgdef(val) {
  //     //console("ssssss")
  //     this.bottomScrollClick();
  //   }
  // },
  // computed: {
  //     elementHeight() {
  //       return this.$refs.msgref.offsetHeight
  //     }
  //   },
  //   watch: {
  //     elementHeight(newHeight, oldHeight) {
  //       console("watch")
  //       // 当元素的高度发生变化时，这里的代码会被执行
  //       this.bottomScrollClick();
        
  //     }
  //   },
  methods: {
    sendTextMessage(){
      this.editor.insertBreak();
      //console.log("sendTextMessage")
    },
    keyupCEnter(e){
      this.editor.insertBreak();
      //console.log("keyupCEnter")
      //console.log(e)
    },
    getEmptyText(text){
      text = this.removeHTMLTags(text);
      text = text.replace(/\ +/g, "").replace(/[\r\n]/g, "");
      return text;
    },
    keyupEnter(){
      //console.log("keyupEnter")
      let text = this.getEmptyText(this.editor.getText())
      //console.log('003: '+text+"--")
      //console.log('00: '+this.removeHTMLTags(this.editor.getText())+"--")
      if(this.editor.isEmpty() || text ==''){
        this.$message.info("数据为空不能发送");
        return
      }
      if(this.pickSend!=-1)
      {
        this.$message.info("请稍后发送");
        return
      }
      this.$nextTick(() => {
        this.sendMessage();
      })

   },
    getCopyType(tid){
      return this.typeMsgLisg[tid]
    },
    async getData(){
      let data= await aiapi.getModle({
         promptBizType: '',
        });
        // this.nextDataId = data.nextDataId;
        // this.hasMore = data.hasMore;
        let i = 0;
        this.modles=[];
        //console.log(data.pageData)
        if(data.pageData&& data.pageData.length>0){
          while(data.pageData.length>i){
            let m = [];
            for(let j= 0;j <4;++j){
              let d = data.pageData[i];
              if(d){
                m.push(d);
                i++;
              }
            }
            this.modles.push(m);
          }
        }
        //console.log( this.modles)
        
    },
    handleResizeInput(height ){
      console.log("handleResizeInput")
      console.log(height)
      let escroll = this.$refs.escroll;
        // console
      escroll.scrollTo({ top: height, behavior: 'smooth' });


      let main = this.$refs.inputref;
      //console.log(main.offsetHeight)
      // main.style.height -=(escroll.height-30)
      // console.log('sss')
      // console.log(escroll.style.height)
      // console.log(main.style.height)
      this.mheight = 635-main.offsetHeight+50+'px'

      //let panel = this.$refs.panelscroll;

      this.pheight = -main.offsetHeight+50+'px'
      this.bottomScrollClick() 
    },
    handleResize({ width, height }) {
      //console.log('handleResize', width, height);    
       this.bottomScrollClick();
    },
    // handleResize() {
    //   const width = this.$refs.msgdef.offsetWidth;
    //   const height = this.$refs.msgdef.offsetHeight;
    //   this.bottomScrollClick();
    //   // 在这里处理宽高变化的逻辑
    //   console.log('盒子宽度:', width, '盒子高度:', height);
    // },
    // watchSize() {
    //   const _this = this;
    //   var erd = elementResizeDetectorMaker();
    //   erd.listenTo(this.$refs.msgdef, (element) => { // 这里的this.$refs.fan指定要监听的元素对象，对应的是<div ref="fan"></div>
    //     var width = element.offsetWidth;
    //     var height = element.offsetHeight;
    //     _this.$nextTick(() => { // 这里填写监听改变后的操作
    //       this.bottomScrollClick();
    //     });
    //   });
    // },

    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      this.bottomScrollClick()
      this.editor.focus()
    // this.onFocus();
    },
    onDestroyed(editor) { console.log('onDestroyed', editor) },
    onFocus(editor) { 
      console.log('onFocus', editor)
      this.$nextTick(() => {
      this.eFocus = true;
      })
    },
    onBlur(editor) { 
      console.log('onBlur', editor)
      this.$nextTick(() => {
        this.eFocus = false;
      })
  
    },
    onChange(editor) { 
      //console.log('onChange', editor.children) 
      //editor.children[editor.children.length-1].children[0].text='44'
      //console.log(event)
      //callback(false) 
      let escroll = this.$refs.escroll;
     // console.log(escroll.scrollTop)
       this.$nextTick(() => {
        //console.log(this.htmlScrollTop )
        //console.log(this.htmlScrol )
        //console.log(escroll.scrollHeight )
        if(this.htmlScrol != escroll.scrollHeight)
        //this.eHtmlList
          this.handleResizeInput(escroll.scrollTop+escroll.scrollHeight-this.htmlScrol)
         // this.sendBtnOff=-42-main.offsetHeight+89+'px'
         // console.log(this.sendBtnOff)
         this.htmlScrol = escroll.scrollHeight//高度
         //this.htmlScrollTop = escroll.scrollTop//位置
         })
    },
    customPaste(editor, event, callback) {
      // this.$nextTick(() => {
      //   this.$refs.typeref[this.$refs.typeref.length-1].addMsg('<p>123dfsdfsdfsdfsdf12123123123dfsdfsdfsdfsdf12123123123dfsdfsdfsdfsdf12123123</p>');
      // })

      //this.$refs.typeref.$emit("addMsg");
      
        console.log('ClipboardEvent 粘贴事件对象', event)
        // const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
        // const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
        // const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）

        // 自定义插入内容
       // editor.insertText('xxx')

        // 返回 false ，阻止默认粘贴行为
      //  event.preventDefault()
        //callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）

        // 返回 true ，继续默认的粘贴行为
        // callback(true)
    },
    bottomScrollClick() {
      //console.log("bottomScrollClick")
      this.$nextTick(() => {
        let scrollEl = this.$refs.mianscroll;
        if(scrollEl)
          scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
    })},
    getEndString(str,div1,div2){
      let rstr = -1;
      let sString = str.substring(str.length-div2.length,this.html.length)
      //console.log(sString)
      if(sString == div2){
        sString = str.substring(0,str.length-div2.length)
        //console.log(sString)
        let lastIndex = sString.lastIndexOf(div1);
          //console.log(lastIndex);
        let sString1 = sString.substring(0,lastIndex);
      // console.log('-'+sString1)
        let sString2 = sString.substring(lastIndex+div1.length,sString.length);
      // console.log('--'+sString2)
        sString = sString1.concat(sString2)
        rstr = sString;
      }
      return rstr
    },
      // delLastStr(str, target){
      //   let arr = str.split(target)
      //   let isF = false;
      //   arr.map(function(item, index){
      //     if(item === target &&!isF){
      //       arr.splice(index, 1)
      //       isF = true;
      //     }
      //   })
      //   return arr.join('')
      // },
    sendMessage() {
      if(!this.editor.getText())return;
      //this.html='<p style="background-color: #e843e8;cursor: pointer;">s22ss</p>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2><h2>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2><h2>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2>'
      //this.html='<div style="background-color: #e848e8;">s33ss</div>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2><h2>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2><h2>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2>'
       //         '<div style="background-color: #e848e8;">s33ss</div>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2><h2>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2><h2>sdfsdf<strong>sdfsdf</strong><s><em><strong>sdfsdfsdfssd</strong></em></s><em><strong>fsdf</strong></em></h2>'
      // this.inputText='sdf'
     //this.html='"<p class=\"ql-align-justify\">On May 25, 2023, the \"Grasp the Trend·Master the Future\" Digital Nomad Era - the Gig Economy Digital Transformation Forum was successfully held at the Beijing National Digital Base. This meeting was hosted by Lucas GC Limited, organized by Beijing Jucai Zhenbang Enterprise Management Consulting Co., Ltd. and the Gig Economy Institute, guided by the Human Capital Branch of China Association of Small and Medium Commercial Enterprises, and supported by the Beijing National Digital Publishing Base and New Star Deling (Beijing) Internet Technology Co., Ltd. This meeting has the honor of inviting leaders from the Human Capital Branch of the China Association of Small and Medium sized Commercial Enterprises, the China Tendering and Bidding Magazine, the Liaison Office of Yuxian County in Beijing, the Jingwan Innovation and Entrepreneurship Platform, and the Beijing National Digital Development Base to attend. On site, there are seven active city operators including Shenzhen, Tianjin, Xian, and Shenyang, with over 60 human resources enterprises participating together.</p><p class=\"ql-align-justify\">This conference focuses on the digital nomadic era, the new direction of the gig economy, the development trends and employment security in the gig economy era, the exploration and practice of the sharing economy in the human resources industry, the exploration and practice of digital transformation in human resources enterprises, and the digital transformation solutions for traditional human resources companies.</p><p class=\"ql-align-justify\">Lucas GC Limited&nbsp;was established in 2011. It is a Specialized and Sophisticated SME&nbsp;in Beijing. It was listed on the New Third Board in 2016. It is a high-tech enterprise focusing on applying innovative technologies such as big data, artificial intelligence, and block-chain to PaaS human resources services. Its leading products include ChatGPT, artificial intelligence algorithms, and PaaS models as the core of enterprise employment, health management, and vocational training services company.</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/d3f776d3-ab5f-48be-bde9-797c9386d43a.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">Howard Lee, <span style=\"color: rgb(1, 12, 19);\">the founder and CEO&nbsp;of Lucas</span>,&nbsp;shared the development trend of digital homeless people, the pain points of enterprise employment, the demand analysis of digital homeless people, the future working mode and the technological innovation and application of digital homeless people. At the same time, the Lucas digital nomad platform (Columbus social employment platform, Star Workplace AI+PaaS platform, Youpaihuo one-stop flexible employment platform) and the application scenarios of the platform related patented technologies are introduced.</p><p class=\"ql-align-justify\">Howard Lee stated, \"With the rapid development of Chinas digital economy and the post-epidemic era, the employment mode of enterprises is changing, and the way of talent sharing is recognized. Digital nomads are both the direction and the trend. Lucas will accelerate its layout in the digital economy, give full play to its technological advantages and patent advantages in AI+PaaS, big data, blockchain ChatGPT and other aspects, improve enterprise operational efficiency and achieve cost reduction and efficiency increase.\"</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/e93480a1-c99e-4df8-a119-9d34a0b18662.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">Mr. Zhang Yunyu, a specially invited lecturer, shared&nbsp;with everyone the development trends and employment security in the era of part-time work economy. Mr. Zhang&nbsp;shared from four perspectives, namely the essence of the flexible employment industry, the past and present, the problems faced, and the future development of flexible employment from a tributary to the mainstream. Mr. Zhang&nbsp;introduced through specific examples that the development of flexible employment is closely related to the adjustment of industrial structure, population changes, technological development, and the employment demand generated during the epidemic. The exploration of the Lucas&nbsp;digital nomad platform also provides technical support for the development of digital nomads and the gig economy. In the face of the development of flexible employment, attention needs to be paid to legal, policy, and security issues. In the future, each of us will participate in flexible employment and become a member of digital nomads.</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/1dfbb6df-862d-4f05-b79b-bfc9ea7cbce9.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">Regarding the exploration and practice of the sharing economy in the human resources industry, Mr. Feng Linsheng, founder of the Lucas&nbsp;Business Alliance, shared with us three explorations and practices of Lucas&nbsp;in the human resources industry.</p><p class=\"ql-align-justify\">The digital transformation of enterprises not only requires the support of platforms and technologies, but also requires comprehensive service and operational system support. Lucas&nbsp;launched the Certified Career Resources Planner (CCRP) as a registered professional resource planner, marking the first time in China that resource integration has been recognized as a professional standard. Lucas&nbsp;and Jilin Research Institute of Jilin University jointly established the Digital Wanderer Research Center and published \"The Era of Digital Wanderers\" as a guide textbook for CCRP registered professional resource planners, clarifying the development process, industry guidelines, and standards of the CCRP profession. CCRP covers five major directions: health management, enterprise recruitment, vocational training, team building, and resource realization, as well as six major privileges including training privileges, product privileges, service privileges, activity privileges, operation privileges, and workplace privileges. A systematic curriculum system, clear training operation mode, and professional lecturer team can provide comprehensive empowerment for CCRP registered professional resource planners, with an exclusive honor system and promotion system to accompany their growth. The establishment of the CCRP system can greatly reduce the market acquisition cost of human resources companies, and also provide a new development direction for human resources practitioners.</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/d3294789-d14a-43bb-984d-5a23c3d07e3e.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">Mr. An Qiang, founder of Beijing Jucai Zhenbang and General Manager of Youpaihuo Beijing, shared with us the theme of \"Exploration and Practice of Digital Transformation in Human Resources Enterprises\". Mr. An Qiang has been deeply involved in the industry for more than ten years, and has been a participant and witness of industry development along the way. Mr. An Qiang analyzed the current situation of traditional human resources companies. As an entrepreneur with pioneering thinking and forward-looking vision, in the face of transformation and development, Mr. An Qiang chose to cooperate with Lucas&nbsp;and jointly launch the \"Youpaihuo one-stop flexible employment service supply chain platform\". The founder of Lucas&nbsp;has a global perspective, as well as advantages such as high team level, strong financing ability, and strong technological research and development ability. Faced with the huge development space of the gig market, it is now a good time to cooperate with Youpaihuo. On the Youpaihuo platform, enterprises can enjoy dual brand linkage support, operational empowerment support, enhance brand effectiveness, and enhance their ability to continue financing; Create an exclusive private domain traffic pool to achieve data sedimentation and activation; CCRP registered professional resource planner training system support, to improve continuous talent integration capabilities for enterprises, recruit talents for teams, and enhance team delivery capabilities; AI+technology research and development support, helping enterprises achieve full process online and digital management through the system; On the Lucas&nbsp;Youpaihuo platform, the security of funds that enterprises pay attention to is guaranteed.</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/27498511-1999-442f-b53e-d46e4a7400aa.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">Mr. Xiao Yixin, the person in charge of Lucas&nbsp;Youpaihuo, shares the theme of \"Digital Transformation Solutions for Traditional Human Resources Companies\" with everyone. Lucas&nbsp;Youpaihuo Platform is positioned as a \"one-stop flexible employment service supply chain platform for enterprises\", hoping to link upstream and downstream resources for enterprises and human resources companies through the platform, and jointly create a mutually beneficial and cooperative platform. The demand for the establishment of Lucas&nbsp;Youpaihuo project comes from the market, and the development of Lucas&nbsp;Youpaihuo serves the market. Lucas&nbsp;Youpaihuo has five empowering comprehensive solutions, leveraging the four core advantages of brand linkage, operation promotion, CCRP training and certification, and AI+big data system. Combined with the five major platform products, Lucas&nbsp;Youpaihuo leverages the technical advantages of AI personnel and job matching, path search, ChatGPT, and other aspects, Assist traditional human resources companies in digital transformation and upgrading.</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/7f13bae3-17ea-4814-b904-6038b7846cf4.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">Under the witness of guests Howard Lee, founder and CEO of Lucas, Huang Yue, head of Lucas&nbsp;operations, Feng Linsheng, president of Lucas&nbsp;Business Alliance, An Qiang, founder and general manager of Jucai Zhenbang, and Zhang Feihu, founder of Zhongxin Energy Cloud Platform, as well as all on-site guests, Youpaihuo officially launched the recruitment of \"Ten Cities and Ten Cities\" city operators. In the future, Youpaihuo will select 10 human resources enterprises in 10 cities across the country, Jointly promote the development and promotion of Youpaihuo.</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/3d2cbc98-8d25-49aa-b6d6-8624a70d9172.png\" width=\"470\"></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\">On May 25th, we standed&nbsp;at a brand new starting point. Lets work together to steadily navigate the digital wave and sail towards the other shore of success!</p><p class=\"ql-align-justify\">&nbsp;</p><p class=\"ql-align-justify\">Welcome to scan the QR code for more information about Lucas&nbsp;Youpaihuo~</p><p class=\"ql-align-justify\"><img src=\"https://file.qingflow.com/documents/form/rtf/6118571c1469A5A/d297269c-7dec-4e74-aba1-e6401fbbd297.png\" width=\"299\"></p><p class=\"ql-align-center\"><br></p><p>&nbsp;</p>"'
      //this.html="<p>sdfsdfsdfsdfsdfsddddddddddddddddddfsdfd</p><p>52323234gdffgd242323423456456456456342433</p><p>sdfs3423423423423423423dfsdfsdfsdfsdfsdfd</p>"
     //console.log(this.html)

     let sString=this.html;
      let doList = [['<p>','</p>']]
      for(let i = 0;i<doList.length;++i){
        let item = doList[i];
        //console.log(item)

        let ss = this.getEndString(this.html,item[0],item[1]);
        //console.log(ss)
        if(ss!=-1){
          sString = ss;
        }
      }
    // let sString = this.html.substring(this.html.length-4,this.html.length)
    // console.log(sString)
    // if(sString == '</p>'){
    //   sString = this.html.substring(0,this.html.length-4)
    //   //console.log(sString)
    //   let lastIndex = sString.lastIndexOf('<h2>');
    //     //console.log(lastIndex);
    //   let sString1 = sString.substring(0,lastIndex);
    //  // console.log('-'+sString1)
    //   let sString2 = sString.substring(lastIndex+3,sString.length);
    //  // console.log('--'+sString2)
    //   sString = sString1.concat(sString2)
    // }
    
    // else{
    //   sString = this.html;
    //}

   // console.log(sString)
    // let result = this.html.replace(new RegExp('<p>', 'g'), '');
    // result = result.replace(new RegExp('</p>', 'g'), '');
    // console.log(result); // 输出: Hello World!

    let text = this.getEmptyText(this.editor.getText())
      if (text!='') {
        // this.html = '<p></p>';
        //console.log(this.html)
        let that = this;
        let tid = Date.now()+'0'
        this.messages.push({ id: Date.now(), text: sString, isMe: true});
        this.messages.push({ id: tid, text: '', isMe: false});
        this.typeMsgLisg[tid]=''
        aiapi.chat(this.conversation,sString,function(conversation,finish,msg){
          if(conversation)
            that.conversation = conversation;
          let ref = that.$refs.typeref[that.$refs.typeref.length-1]
          if(finish) {
            if(ref){
              ref.setEnd(true);
            }
            console.log('end')
            that.onEnd();
          }
          if(!finish) {
            if(ref){
              ref.addMsg(msg);
            }
            that.typeMsgLisg[tid]+=msg;
          }
          // this.$nextTick(() => {
            
          // })
        
        })
        this.$nextTick(() => {
          //ffthis.html='';
          //this.editor.setHtml('');
          this.editor.clear()
        })
    
      }
      this.bottomScrollClick();
      // console.log(this.editor.getConfig())
      // console.log(this.editor)
      // this.html=this.inputText;
      this.pickSend = 1;
    },
    onMsgEnter(msg){
     // console.log("onMsgEnter")
      this.isMsgEnter = msg;
      //console.log( this.isMsgEnter)
    },
    onMsgOut(){
     // console.log("onMsgOut")
      this.isMsgEnter = '';
    },
    onSendEnter(){
      //滑过
      this.pickSend = 0
    },
    onSendOut(){
      if( this.pickSend == 0){
        //console.log("this.pickSend ")
        this.pickSend = -1;
      }
    },
    removeHTMLTags(text) {
      return text.replace(/<[^>]+>/g, '');
    },
    toPickMsg(msg){
      //console.log(this.removeHTMLTags(msg))
    },
    onMsgEnd(){
      this.pickSend = -1;
    },
    clearMsg(){
      this.messages=[];
      this.conversation = '';
      this.pickSend = -1;
      let ref = this.$refs.typeref[this.$refs.typeref.length-1]
      if(ref){
        ref.close();
      }
     
    },
    initHistory(id,list){
      this.conversation = id;
      this.pickSend = -1;
      this.messages=[];
      for(let m in list){
        this.messages.push({ id: list[m].messageId+'me', text: list[m].userMessage, isMe: true,time:list[m].createdAt});
        this.messages.push({ id: list[m].messageId, text: list[m].aiMessage, isMe: false,isnType:true });
      }
      let ref = this.$refs.typeref?this.$refs.typeref[this.$refs.typeref.length-1]:null
      if(ref){
        ref.close();
      }
      // this.$refs.typeref[that.$refs.typeref.length-1].setEnd(true);
    },
    onPanelEnter(i,ii){
      this.pindex = i
      this.piindex = ii
    },
    onPanelOut(){
      this.pindex = -1
      this.piindex = -1
    },
    onPanel(i,ii,id,msg){
     //this.applyId = id;
      this.html = msg;
    },
    copyUrl() {
     //this.promotionLinks = false;
      console.log("复制成功！");
      this.$message.info("复制成功！");
    },
    onError(){
      console.log("复制sv！");
      this.$message.info("复制失败！");
    }
  },
  beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
  }
};
</script>
<style scoped lang="scss">
*::-webkit-scrollbar {
	display: none;
}
* {
	-ms-overflow-style: none;
}
* {
	scrollbar-width: none;
}
  ::-webkit-scrollbar {
    display: none;
  }
  ::inner {
    overflow: auto;
  }
  ::-webkit-scrollbar {
    width: 0 !important;
  }
.chat-window {
  width: 890px;
  min-width: 890px;
  height:766px;
  margin: 0 auto;
  // border: 2px solid rgba(240, 242, 245, 1);
  border-radius: 6px;
  .icon-btn{
    background-color: rgba(0, 0, 0, 0);
    border: none;
    size:large;
    color:#0fe73a;
  }

  .panel{
    // display: flex;
    // flex-direction: column;
    width: 100%;
    padding-top: 50px;
    overflow: hidden;
    // align-self:center;
    // justify-content: center;
    // justify-self: center;
    // justify-items: center;
    text-align: center;
    height: 655px;
    .modlePanel{
      width: 100%;
      //height: 300px;
      // border: 2px solid #0fe73a;
      padding: 20px;
      margin-bottom: 10px;
      // margin-top: 10px;
      // display: flex;
      // flex-direction: row;
      .modle{
          display: flex;
          flex-direction: column;
          text-align: left;
          width: 310px;
          height: 113px;
          border-radius: 6px;
          background-color: rgba(0, 0, 0, 0.05);
         // padding: 20px;
         padding-left: 20px;
         padding-top: 20px;
          margin: 10px;
          cursor: pointer;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
    
      }
      .modle1{
        background-color: rgba(255, 255, 255, 1);
        box-shadow:  0px 3px 6px rgba(0, 0, 0, 0.20);
        margin-top: -5px;
      }
      .modle2{
        background-color: rgba(0, 0, 0, 0.05);
        margin-top: 0px;
      }
      .slick-slide {
          text-align: center;
          height: 160px;
          line-height: 160px;
          background: #364d79;
          overflow: hidden;
        }

        .custom-slick-arrow {
          width: 25px;
          height: 25px;
          font-size: 25px;
           color: rgba(119, 136, 255, 1);
          // background-color: rgba(31, 45, 61, 0.11);
          opacity: 0.3;
        }
        .custom-slick-arrow:before {
          display: none;
        }
        .custom-slick-arrow:hover {
          opacity: 0.5;
        }
    }
  }
  
  .input-form{
    float:right;
  }
  .message-container {
      height:510px;
      margin-bottom: 20px;
      overflow:hidden;
      //overflow-y: scroll;
      // border: 1px solid #5ec9ff;
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;
      .time-text{
        text-align: center;
        margin-top: 13px;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
      }
      .left-box {
        float: left;
        margin-left: 120px;
        padding-bottom: 10px;
      }
      .user-img {
        float: left;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #ddd;
        margin-right: 10px;
        position: relative;
        top: 15px;
        overflow: hidden;
      }
      .user-msg {
        float: left;
        padding: 10px;
        background-color: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.75);
        font-size: 14px;
        border-radius: 8px;
        font-weight: Semibold;
        width: 600px;
        text-align: left;
        white-space:break-spaces;
        word-break: break-all;
        line-height:1.5;
        margin-top: 8px;
        min-height: 40px;
       //padding-bottom: 0px;
      }
      .my-msg {
        background-color:rgba(119, 136, 255, 0);
      }
      .other-msg{
        cursor: pointer;
      }
      .pick-msg{
        background-color: rgba(0, 0, 0, 0.10)
      }
      .pick-msg1{
        background-color:rgba(0, 0, 0, 0.05);
      }
      .right-box {
        float: left;
        margin-right: 10px;
      }
      .user-img-right {
        margin-right: 0;
        margin-left: 10px;
      }
   //float: right;
      
      .content-box {
        float: left;
        margin-top: 10px;
        .lbtn{
          width:24px;height:24px;
          margin-left: 8px;
          margin-top: 10px;
          background-color: rgba(119, 137, 255, 1);
         // margin-bottom: 20px;
          }
      }
      .user {
        color: #666;
        font-size: 12px;
        clear: right;
        margin-bottom: 2px;
      }
      .user-my{
       // text-align: right;
      }
      .auto-img{
        //margin-left: 5px;
        //margin-top: 5px;
        width: 100%;
        //height: 70%;
        display: block;
      }
  }
  .inputs{
    // position: absolute; 
    //     bottom: 0;
    width:680px;
    // border: 2px solid rgba($color: #000000, $alpha: 1.0);
    .edits1{
      border: 2px solid rgba(119, 136, 255, 1);
    }
    .edits2{
      border: 2px solid rgba(240, 242, 245, 1);
    }
    .edits{
      border-radius: 6px;
      width:650px;
      overflow-y: scroll;
      overflow:auto; 
      margin-left: 120px;
      min-height: 50px;
      //position: relative;
      // height: 200px;
      // float: left;
    
    }
    .opedit{
      //border: 5px solid rgb(230, 53, 22);
        width: 40px;
        //width: 40px;
        height: 40px;
        //position: absolute; 
        //bottom: 40;
        //top: 0;
        //right: 230px;
       // float:right;
        // position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        //margin-top: -42px;
         margin-bottom: 0px;
         margin-top: -47px;
         margin-left: 725px;
        border-radius: 1px;
        cursor: pointer;
        // text-align: center;
        // align-items: center;
        // float:right;
        .img1{
          filter: grayscale(100%);
          width:24px;
          height: 24px;
        }
        .img{
          width:24px;
          height: 24px;
        }
      }
      .opedit1{
        background-color: rgba(0, 0, 0, 0.05);
      }
      .opedit2{
        background-color:rgba(0,0,0,0)
      }
  }
  ::v-deep.w-e-text-container p{
    line-height:1
  }
  ::v-deep.w-e-text-placeholder{
    font-style:italic;
    left:10px;
    top:13px;
    width:90%
  }
  ::v-deep.w-e-text-container{
    padding: 0,0,0,0;
    padding-top: 0px;
    min-height: 30px;
    // font-size: 12px;
    //height:30px;
    // overflow:hidden;
    // overflow-y:none;
  }
  ::v-deep.w-e-text{
      // overflow-y:none;
      // overflow:hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
  ::v-deep.w-e-drop-panel{
    z-index: 100;
  }
  ::v-deep.w-e-scroll{
    -webkit-overflow-scrolling:touch;
    // overflow: hidden;
    // overflow-y: none;
    height:100%;
    // width: 10;
    scrollbar-width: none;
      -ms-overflow-style: none;
  }
}
.message {
  padding: 5px;
  //margin-bottom: 5px;
}

.message-text {
  max-width:300px;
  padding: 5px;
  border-radius: 5px;
  //margin-bottom: 5px;
}

.other{
  float:left;
  background-color: lightblue;
}
.mine {
  float:right;
  background-color: lightblue;
}
</style>
